<template>
  <AppDialogContent
    v-model="dialog"
    :disabled="loading"
    :loading="loading"
    @submit-form="submit"
  >
    <template #header>
      {{ $t("events:competion.cloneCompetition.heading") }}
    </template>

    <template v-if="canCloneRules">
      <p>
        {{
          $t(
            "events:competion.cloneCompetition.settingForEntryRules.subheading",
            "Choose setting for cloning of competition's entry rules"
          )
        }}
      </p>

      <v-radio-group v-model="cloneCompetitionEntryRules">
        <v-radio
          :label="
            $t(
              'events:competion.cloneCompetition.settingForEntryRules.fromSourceCompetition.label',
              'Keep competition`s entry rules from source event'
            )
          "
          :value="true"
        />
        <v-radio
          :label="
            $t(
              'events:competion.cloneCompetition.settingForEntryRules.fromTemplaten.label',
              'Create entry rules from global template (if set)'
            )
          "
          :value="false"
        />
      </v-radio-group> </template
    ><template v-else>
      {{ $t("events:competion.cloneCompetition.text") }}
    </template>
  </AppDialogContent>
</template>
<script>
import gql from "fraql";
export default {
  name: "EventCompetitionCloneDialog",
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        id
        competitionEntryRules {
          id
        }
      }
    `
  }
};
</script>
<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { injectSnackbarError } from "@composables/injections";
import { apolloClient } from "@/plugins/apollo";
import AppDialogContent from "@elements/AppDialogContent.vue";
import { useCompetitionEntryRuleTemplatesHelper } from "@composables/masterdata/competitions/competitionEntryRuleTemplates";

const props = defineProps({
  event: {
    type: Object,
    required: true
  }
});

const { masterCompetitionEntryRuleTemplatesActive } =
  useCompetitionEntryRuleTemplatesHelper();

let callbackMutation = null;

const dialog = ref(false);
const competition = ref(null);
const { snackbarServerError } = injectSnackbarError();
const loading = ref(false);
const cloneCompetitionEntryRules = ref(true);

const router = useRouter();

function openForm(c, cb = null) {
  callbackMutation = cb;
  competition.value = c;
  cloneCompetitionEntryRules.value = true; // default value
  dialog.value = true;
}

defineExpose({
  openForm,
  callbackMutation
});

const canCloneRules = computed(() => {
  return (
    competition.value?.competitionEntryRules?.length > 0 ||
    masterCompetitionEntryRuleTemplatesActive.value.some(
      c => c.disciplineId == props.event.disciplineId
    )
  );
});

async function submit() {
  try {
    loading.value = true;

    const { data } = await apolloClient.mutate({
      mutation: gql`
        mutation eventCompetitionClone(
          $id: ID!
          $cloneCompetitionEntryRules: Boolean
        ) {
          eventCompetitionClone(
            input: {
              id: $id
              cloneCompetitionEntryRules: $cloneCompetitionEntryRules
            }
          ) {
            competition {
              id
            }
          }
        }
      `,
      variables: {
        id: competition.value.id,
        cloneCompetitionEntryRules: cloneCompetitionEntryRules.value
      }
    });

    if (typeof callbackMutation === "function") {
      callbackMutation(data);
    } else {
      router.push({
        name: "CompetitionEditPage",
        params: {
          competitionId: data.eventCompetitionClone.competition.id,
          eventId: props.event.id
        }
      });
    }
  } catch (error) {
    snackbarServerError(error, { level: "error" });
  } finally {
    loading.value = false;
  }
}
</script>
